import { useQuery } from 'react-query';

// import { ContactInquiry } from '../../type';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export const getContactInquiry = async (): Promise<any> => {
    const { data } = await axios.get(`v1/admin/inquiries/get-contact-us-inquiries`);

    return data;
};

type QueryFnType = typeof getContactInquiry;

type UseCorpsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useContactInquiry = ({ config }: UseCorpsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['contactInquiry'],
        queryFn: () => getContactInquiry(),
    });
};
